import { IconButton } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"
import { BsThreeDotsVertical } from "react-icons/bs"
import { FiBarChart2, FiClock, FiEdit2, FiMessageSquare } from "react-icons/fi"

import type { QuestionPublic } from "@/client"
import {
  MenuContent,
  MenuItem,
  MenuRoot,
  MenuTrigger,
} from "@/components/ui/menu"

import DeleteQuestion from "./DeleteQuestion"

interface QuestionActionsMenuProps {
  question: QuestionPublic
  canDelete: boolean
}

export const QuestionActionsMenu = ({
  question,
  canDelete,
}: QuestionActionsMenuProps) => {
  return (
    <MenuRoot>
      <MenuTrigger asChild>
        <IconButton
          variant="ghost"
          color="inherit"
          aria-label="Question actions"
        >
          <BsThreeDotsVertical />
        </IconButton>
      </MenuTrigger>
      <MenuContent>
        <Link to={`/questions/${question.id}/edit`}>
          <MenuItem
            closeOnSelect
            value="edit-question"
            gap={2}
            py={2}
            style={{ cursor: "pointer" }}
          >
            <FiEdit2 fontSize="16px" />
            Edit Question
          </MenuItem>
        </Link>
        <Link to={`/questions/${question.id}/history`}>
          <MenuItem
            closeOnSelect
            value="view-history"
            gap={2}
            py={2}
            style={{ cursor: "pointer" }}
          >
            <FiClock fontSize="16px" />
            View History
          </MenuItem>
        </Link>
        <Link to={`/questions/${question.id}/analytics`}>
          <MenuItem
            closeOnSelect
            value="view-analytics"
            gap={2}
            py={2}
            style={{ cursor: "pointer" }}
          >
            <FiBarChart2 fontSize="16px" />
            View Analytics
          </MenuItem>
        </Link>
        <Link to={`/questions/${question.id}/feedback`}>
          <MenuItem
            closeOnSelect
            value="view-feedback"
            gap={2}
            py={2}
            style={{ cursor: "pointer" }}
          >
            <FiMessageSquare fontSize="16px" />
            View Feedback
          </MenuItem>
        </Link>
        {canDelete && <DeleteQuestion question={question} />}
      </MenuContent>
    </MenuRoot>
  )
}
